<template>
	<div class="container">
		<h1 class="mb-5">{{ resultTitle }}</h1>

		<div class="results">
			<div
					class="result mb-4"
					v-bind:key="i"
					v-for="(result, i) in results"
			>
				<div class="d-flex">
					<h1 class="mb-0 mr-3">
						{{ getLetter(i) }}
					</h1>
					<result-progress-bar
						v-bind:index="i"
						v-bind:percentage="result.percentage"
					/>
				</div>

				<choice-text
					class="text mt-2"
					v-bind:text="result.text || result.message"
				/>

				<app-button
						class="pick-choice-button"
						v-if="resultType === 'chooseAnswer' || (resultType === 'correctAnswer' && correctIndex === i)"
						v-on:click.native="pickChoice(i)"
				>{{$t('misc.select')}}
				</app-button>
			</div>
		</div>
		<app-button
				class="pick-choice-button my-5"
				v-if="resultType === 'noAnswer'"
				v-on:click.native="pickChoice(null)"
		>{{$t('misc.continue')}}
		</app-button>
	</div>
</template>

<script>
	import AppButton from '@/components/app-button/index'
	import {mapGetters} from 'vuex'
	import ResultProgressBar from './result-progress-bar'
	import Choice from '@/components/choices/choice'
	import ChoiceText from '@/components/choices/choice-text'
  import ChoiceMessage from '@/components/choices/choice-message'
	import * as MutationTypes from '@/store/mutation-types'

	import PageComponentTemplate from '../page-component-template';

	export default {
		extends: PageComponentTemplate,
		components: {
			Choice,
			ChoiceText,
      ChoiceMessage,
			AppButton,
			ResultProgressBar
		},
		data() {
			return {
				results: []
			}
		},
		mounted() {
			let results = []

			let voteCounts = this.$gameClient.room.state.voteCounts
			let voteCountsLength = voteCounts.length
			let totalVotes = 0

			for (let i = 0; i < voteCountsLength; i++) {
				totalVotes += voteCounts[i]
			}

			let i = 0

			for (let choice of this.choices) {
				let choiceVotes = 0

				if (voteCountsLength >= i) {
					choiceVotes = voteCounts[i]
				} else {
					console.warn(`Could not find vote by index ${i}`)

					choiceVotes = 0 // hmm.. how can that be possible?
				}

				results.push({
					percentage: totalVotes > 0 ? Math.round((choiceVotes / totalVotes) * 100) : 0,
					text: choice.text
				})

				i++
			}

			this.results = results
			this.addVotesToSession();
		},
		computed: {
			...mapGetters({
				currentCase: 'getCurrentCase',
			}),
			resultTitle() {
				if (this.resultType === 'chooseAnswer') {
					return this.$t('game.chooseAnswer');
				}

				return this.$t('game.showAnswers');
			},
			choices() {
				return this.options.choices;
			},
			resultType() {
				return this.options.resultType;
			},
			correctIndex() {
				return this.options.correctIndex;
			}
		},
		methods: {
			pickChoice(choiceIndex) {
				let choice = this.choices[choiceIndex]

				this.$emit('pickChoice', choice);
			},
			addVotesToSession() {
				const voteCounts = this.$gameClient.room.state.voteCounts;
				const actualVoteCounts = [];

				for (let i = 0; i < this.choices.length; i++) {
					actualVoteCounts.push(voteCounts[i]);
				}

				this.$store.commit(MutationTypes.ADD_VOTES, actualVoteCounts);

				if (this.isTeacher && this.$store.state.sessionId) {
					const data = {
						responses: this.$store.state.session.responses
					};
					this.$apiClient.updateSession(this.$store.state.sessionId, data, () => {}, () => {});
				}
			},
			getLetter(index) {
				switch(index) {
					case 0:
						return 'A';
					case 1:
						return 'B';
					case 2:
						return 'C';
					case 3:
						return 'D';
					case 4:
						return 'E';
					case 5:
						return 'F';
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	@import "~@less/variables.less";

	.result {
		.text {
			transform: scale(0.8);
			border-left: 3px solid @blackish;
			padding-left: 10px;
		}
	}
</style>
